// extracted by mini-css-extract-plugin
export default {"container":"ConfirmPopup_container__9Ibop","popup":"ConfirmPopup_popup__gpuze","title":"ConfirmPopup_title__5Jxga","btnWrapper":"ConfirmPopup_btnWrapper__BmwkZ"};